// 안내문은 다음 응답 문항과 함께 보여주고 마지막 안내문은 마지막 단계에 포함합니다.
export function buildSurveySteps(questions) {
    const steps = [];
    let instructions = [];
    questions.forEach(question => {
        if (Number(question.question_type_id) === 10) instructions.push(question.question_id);
        else {
            steps.push({ question, ids: [...instructions, question.question_id] });
            instructions = [];
        }
    });
    if (instructions.length && steps.length) steps[steps.length - 1].ids.push(...instructions);
    return steps;
}

export function isMissingAnswer(question, answers) {
    const type = Number(question.question_type_id);
    const value = answers[question.question_id];
    if (type === 10) return false;
    if (type === 6) return !Array.isArray(value) || !value.length || value.some(item => !item?.url);
    if (type === 4) return !Array.isArray(value) || !value.length || value.some(item => (/^기타\|/.test(item) && !item.slice(3).trim()) || item === '기타');
    if (type === 2 && (value === '기타' || String(value || '').startsWith('기타|'))) return !String(value).split('|')[1]?.trim();
    if (type === 3) return !(Number(value) > 0);
    return !String(value ?? '').trim();
}

export function answerSummary(question, answers) {
    const value = answers[question.question_id];
    if (Number(question.question_type_id) === 6) return Array.isArray(value) ? value : [];
    const format = item => String(item ?? '').replace(/^기타\|/, '기타: ');
    if (Array.isArray(value)) return value.map(format).join(', ');
    if (Number(question.question_type_id) === 3 && value) return `${value}점`;
    return format(value);
}

export function ratingScores(question) {
    const maximum = Number(question.max_score) > 0 ? Number(question.max_score) : 5;
    const increment = Number(question.step) > 0 ? Number(question.step) : 0.5;
    const scores = Array.from({ length: Math.floor(maximum / increment) }, (_, index) => Number(((index + 1) * increment).toFixed(4)));
    if (scores[scores.length - 1] !== maximum) scores.push(maximum);
    return scores;
}
